import moment from 'moment'

const transformData = () => {
  const transformArrayObject = (data: Array<any>, fieldTransform: any) => {
    if (!fieldTransform) return data
    if (!data || data.length === 0) return []
    return data?.map((item: any) => {
      const objectResult: any = {}
      Object.keys(fieldTransform).forEach((key: string) => {
        if (fieldTransform[key] === '') {
          objectResult[key] = item
        } else {
          objectResult[key] = item[fieldTransform[key]]
        }
      })
      return objectResult
    })
  }

  const timeSLotPipe = (timeStamp?: number | string): string => {
    if (!timeStamp) return ''
    return moment(timeStamp).format('HH:mm')
  }

  return { transformArrayObject, timeSLotPipe }
}
export default transformData
